import React, { useState, useRef, useEffect } from "react";
import { last, startCase, toLower } from "lodash";
import jsDig from "utils/jsDig";
import formatMetric from "utils/formatMetric";
import CustomTooltip from "utils/CustomTooltip";

export default function LiteMetricTable(props) {

  const [isDarkMode, setIsDarkMode] = useState(document.body.classList.contains('dark-theme'));

  let chevronDown = require("images/lite/icons/chevron-down.png");
  chevronDown = <img className="table-icon chevpdf" src={`/datapulse${chevronDown}`} />;
  let chevronUp = require("images/lite/icons/chevron-down.png");
  chevronUp = <img className="table-icon chevpdf" src={`/datapulse${chevronUp}`} style={{
  transform: 'rotate(180deg)'
  }} />;

  useEffect(() => {
    const handleThemeChange = () => {
      setIsDarkMode(document.body.classList.contains('dark-theme'));
    };

    // Attach a mutation observer to listen for changes in the body class
    const observer = new MutationObserver(handleThemeChange);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);

  const metaAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M33.8404 9C30.1384 9 27.2444 11.788 24.6244 15.33C21.0244 10.746 18.0144 9 14.4124 9C7.06843 9 1.44043 18.56 1.44043 28.676C1.44043 35.006 4.50243 39 9.63243 39C13.3244 39 15.9804 37.26 20.7024 29.006C20.7024 29.006 22.6704 25.532 24.0224 23.138C24.4984 23.904 24.9964 24.728 25.5224 25.614L27.7364 29.338C32.0484 36.554 34.4524 39 38.8044 39C43.8044 39 46.5844 34.952 46.5844 28.49C46.5844 17.896 40.8304 9 33.8404 9ZM17.1004 26.772C13.2744 32.772 11.9504 34.118 9.82043 34.118C7.62643 34.118 6.32243 32.192 6.32243 28.758C6.32243 21.414 9.98443 13.904 14.3504 13.904C16.7144 13.904 18.6904 15.268 21.7164 19.6C18.8424 24.008 17.1004 26.772 17.1004 26.772ZM31.5504 26.018L28.9004 21.6C28.2352 20.5136 27.547 19.4413 26.8364 18.384C29.2224 14.702 31.1884 12.866 33.5304 12.866C38.3904 12.866 42.2804 20.026 42.2804 28.818C42.2804 32.17 41.1824 34.116 38.9084 34.116C36.7284 34.116 35.6884 32.676 31.5484 26.016"/>
    </svg>
  );

  const googleAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M41.3552 34.153L29.5222 8.77603C28.8497 7.33378 27.6317 6.21779 26.1363 5.67356C24.6409 5.12933 22.9905 5.20144 21.5482 5.87403C20.106 6.54662 18.99 7.76459 18.4458 9.26001C17.9015 10.7554 17.9737 12.4058 18.6462 13.848L30.4802 39.224C31.1527 40.6663 32.3706 41.7823 33.8659 42.3266C35.3612 42.871 37.0115 42.799 38.4537 42.1265C39.896 41.4541 41.012 40.2362 41.5564 38.7409C42.1007 37.2456 42.0277 35.5953 41.3552 34.153Z" stroke={isDarkMode ? "white" : "black"} stroke-width="4"/>
      <path d="M23.438 26.536L17.52 39.224C17.187 39.9382 16.7166 40.5797 16.1356 41.1121C15.5547 41.6444 14.8745 42.0571 14.1341 42.3266C13.3936 42.5961 12.6073 42.717 11.8201 42.6826C11.0329 42.6482 10.2601 42.4591 9.546 42.126C8.10396 41.4535 6.98811 40.2357 6.44389 38.7405C5.89967 37.2453 5.97165 35.5951 6.644 34.153L18.374 9" stroke={isDarkMode ? "white" : "black"} stroke-width="4" stroke-linecap="round"/>
      <path d="M9.54709 42.1259C12.5503 43.5263 16.1202 42.227 17.5206 39.2237C18.9211 36.2205 17.6218 32.6506 14.6185 31.2502C11.6153 29.8498 8.04539 31.1491 6.64495 34.1523C5.24452 37.1556 6.54385 40.7254 9.54709 42.1259Z" stroke={isDarkMode ? "white" : "black"} stroke-width="4"/>
    </svg>
  );

  const microsoftAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.002 10H10.002V22H22.002V10ZM26.002 10V22H38.002V10H26.002ZM38.002 26H26.002V38H38.002V26ZM22.002 38V26H10.002V38H22.002ZM6.00195 6H42.002V42H6.00195V6Z"/>
    </svg>
  );

  const socialIcon = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
     <path d="M8 4C7.73478 4 7.48043 4.10536 7.29289 4.29289C7.10536 4.48043 7 4.73478 7 5V19C7 19.2652 7.10536 19.5196 7.29289 19.7071C7.48043 19.8946 7.73478 20 8 20H11.5C12.0523 20 12.5 20.4477 12.5 21C12.5 21.5523 12.0523 22 11.5 22H8C7.20435 22 6.44129 21.6839 5.87868 21.1213C5.31607 20.5587 5 19.7957 5 19V5C5 4.20435 5.31607 3.44129 5.87868 2.87868C6.44129 2.31607 7.20435 2 8 2H16C16.7956 2 17.5587 2.31607 18.1213 2.87868C18.6839 3.44129 19 4.20435 19 5V11C19 11.5523 18.5523 12 18 12C17.4477 12 17 11.5523 17 11V5C17 4.73478 16.8946 4.48043 16.7071 4.29289C16.5196 4.10536 16.2652 4 16 4H14C14 4.55228 13.5523 5 13 5H11C10.4477 5 10 4.55228 10 4H8Z"/>
     <path d="M13.9548 14.9152C14.5613 14.3271 15.3733 13.9989 16.2181 14.0005C16.8578 14.0017 17.4781 14.192 18.0038 14.5407C18.5314 14.1932 19.1531 14.0048 19.7936 14.006C20.6386 14.0076 21.4495 14.3391 22.0537 14.9297C22.3541 15.2231 22.5926 15.5736 22.7552 15.9607C22.9179 16.3477 23.0013 16.7635 23.0006 17.1833C22.9999 17.6031 22.9151 18.0186 22.7512 18.4051C22.5877 18.7908 22.3487 19.1399 22.0484 19.4318L18.7 22.7142C18.3109 23.0957 17.6879 23.0954 17.2992 22.7135L13.946 19.4193C13.9457 19.4189 13.9454 19.4186 13.945 19.4183C13.6452 19.125 13.4072 18.7748 13.2449 18.3881C13.0824 18.001 12.9991 17.5852 12.9999 17.1654C13.0007 16.7456 13.0856 16.3301 13.2496 15.9437C13.4136 15.5572 13.6535 15.2075 13.9548 14.9152ZM16.2143 16.0005C15.8906 15.9999 15.5795 16.1256 15.3472 16.3509C15.2376 16.4572 15.1504 16.5845 15.0907 16.725C15.0311 16.8655 15.0002 17.0166 14.9999 17.1693C14.9996 17.322 15.0299 17.4732 15.089 17.6139C15.1481 17.7547 15.2348 17.8822 15.344 17.989L15.3458 17.9908L18.0008 20.599L20.6536 17.9984C20.7632 17.8921 20.8503 17.7649 20.9099 17.6244C20.9695 17.4838 21.0004 17.3327 21.0006 17.18C21.0009 17.0274 20.9705 16.8762 20.9114 16.7354C20.8522 16.5947 20.7655 16.4672 20.6563 16.3605C20.4248 16.1341 20.1136 16.0066 19.7898 16.006C19.4669 16.0054 19.1564 16.1306 18.9243 16.3549L18.7027 16.5726C18.3131 16.9552 17.6885 16.9545 17.2997 16.571L17.0786 16.3529C16.8473 16.1275 16.5373 16.0011 16.2143 16.0005Z"/>
    </svg>
  );

  const tiktokAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.8843 4.03375C27.0812 4 29.2655 4.02 31.4472 4C31.5794 6.55139 32.5035 9.15027 34.3844 10.9541C36.2615 12.803 38.9166 13.6493 41.5 13.9355V20.6471C39.079 20.5684 36.6467 20.0684 34.4498 19.0333C33.493 18.6033 32.6017 18.0495 31.7292 17.4832C31.7179 22.3535 31.7494 27.2175 31.6978 32.0677C31.5668 34.3979 30.7926 36.7167 29.4279 38.6368C27.2322 41.8333 23.4214 43.9171 19.5073 43.9821C17.1065 44.1184 14.7081 43.4683 12.6623 42.2708C9.27197 40.2857 6.88625 36.6517 6.53878 32.7515C6.49501 31.9255 6.48829 31.098 6.51863 30.2714C6.82078 27.1 8.40077 24.0661 10.8532 22.0022C13.633 19.5983 17.527 18.4533 21.1729 19.1308C21.2069 21.5997 21.1074 24.0661 21.1074 26.535C19.4418 25.9999 17.4955 26.1499 16.0401 27.1537C14.9754 27.8502 14.1707 28.875 13.7501 30.0701C13.4026 30.9152 13.5021 31.854 13.5222 32.7515C13.9213 35.4867 16.5701 37.7855 19.3978 37.5368C21.2723 37.5168 23.0689 36.4367 24.0458 34.8554C24.3618 34.3016 24.7156 33.7353 24.7345 33.084C24.8994 30.1026 24.8339 27.1337 24.8541 24.1523C24.8679 17.4332 24.8339 10.7329 24.8856 4.035L24.8843 4.03375Z"/>
    </svg>
  );

  const searchIcon = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.87868 3.87868C3.44129 3.31607 4.20435 3 5 3H19C19.7957 3 20.5587 3.31607 21.1213 3.87868C21.6839 4.44129 22 5.20435 22 6V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V6C20 5.73478 19.8946 5.48043 19.7071 5.29289C19.5196 5.10536 19.2652 5 19 5H5C4.73478 5 4.48043 5.10536 4.29289 5.29289C4.10536 5.48043 4 5.73478 4 6V18C4 18.2652 4.10536 18.5196 4.29289 18.7071C4.48043 18.8946 4.73478 19 5 19H12C12.5523 19 13 19.4477 13 20C13 20.5523 12.5523 21 12 21H5C4.20435 21 3.44129 20.6839 2.87868 20.1213C2.31607 19.5587 2 18.7956 2 18V6C2 5.20435 2.31607 4.44129 2.87868 3.87868ZM6 8C6 7.44772 6.44772 7 7 7H11C11.5523 7 12 7.44772 12 8V12C12 12.5523 11.5523 13 11 13H7C6.44772 13 6 12.5523 6 12V8ZM8 9V11H10V9H8ZM14 8C14 7.44772 14.4477 7 15 7H17C17.5523 7 18 7.44772 18 8C18 8.55229 17.5523 9 17 9H15C14.4477 9 14 8.55229 14 8ZM14 12C14 11.4477 14.4477 11 15 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H15C14.4477 13 14 12.5523 14 12ZM6 16C6 15.4477 6.44772 15 7 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H7C6.44772 17 6 16.5523 6 16Z"/>
      <path d="M16.1603 14.2662C16.585 14.0903 17.0402 13.9998 17.4998 13.9998C17.9595 13.9998 18.4147 14.0903 18.8394 14.2662C19.264 14.4421 19.6499 14.6999 19.9749 15.025C20.3 15.35 20.5578 15.7359 20.7337 16.1606C20.9096 16.5852 21.0002 17.0404 21.0002 17.5001C21.0002 17.9598 20.9096 18.4149 20.7337 18.8396C20.6876 18.9508 20.636 19.0594 20.5789 19.1649L21.7069 20.293C22.0975 20.6835 22.0975 21.3167 21.7069 21.7072C21.3164 22.0977 20.6833 22.0977 20.2927 21.7072L19.1647 20.5791C18.6579 20.8532 18.0864 21.0004 17.4998 21.0004C16.5715 21.0004 15.6812 20.6316 15.0247 19.9752C14.3683 19.3188 13.9995 18.4284 13.9995 17.5001C13.9995 16.5717 14.3683 15.6814 15.0247 15.025C15.3498 14.6999 15.7356 14.4421 16.1603 14.2662ZM17.4998 15.9998C17.3028 15.9998 17.1077 16.0386 16.9257 16.114C16.7437 16.1894 16.5783 16.2999 16.4389 16.4392C16.1576 16.7206 15.9995 17.1022 15.9995 17.5001C15.9995 17.898 16.1576 18.2796 16.4389 18.561C16.7203 18.8423 17.1019 19.0004 17.4998 19.0004C17.8978 19.0004 18.2794 18.8423 18.5607 18.561C18.7001 18.4217 18.8106 18.2563 18.886 18.0742C18.9614 17.8922 19.0002 17.6971 19.0002 17.5001C19.0002 17.3031 18.9614 17.108 18.886 16.9259C18.8106 16.7439 18.7001 16.5785 18.5607 16.4392C18.4214 16.2999 18.256 16.1894 18.074 16.114C17.892 16.0386 17.6969 15.9998 17.4998 15.9998Z"/>
    </svg>
  );

  const amazonAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.6717 36.0421C38.517 36 38.3295 36.0234 38.1139 36.1031C35.2264 37.425 32.4186 38.3671 29.6904 38.925C23.7982 40.125 18.0561 39.4968 12.4686 37.0453C10.917 36.3609 8.76075 35.2078 5.99981 33.5765C5.92867 33.5204 5.84188 33.4876 5.75137 33.4828C5.65762 33.4781 5.57793 33.4875 5.50293 33.525C5.42793 33.5625 5.37168 33.6093 5.3295 33.6703C5.28731 33.7312 5.27793 33.8156 5.31075 33.9234C5.33887 34.0265 5.40918 34.1437 5.52637 34.2703C6.01387 34.8421 6.61856 35.4515 7.33575 36.0984C8.05293 36.7453 9.0045 37.4765 10.1904 38.2921C11.3764 39.1078 12.6186 39.8343 13.9076 40.4671C15.2014 41.1 16.7014 41.6343 18.4123 42.0656C20.1232 42.4968 21.8342 42.7125 23.5404 42.7125C25.2373 42.7125 26.8873 42.539 28.4858 42.2015C30.0889 41.8593 31.4389 41.4562 32.5404 40.9875C33.6373 40.5234 34.6498 40.0031 35.5779 39.4406C36.5061 38.8781 37.1904 38.4 37.6357 38.0203C38.0811 37.6359 38.3998 37.3359 38.5826 37.1109C38.7982 36.8437 38.9061 36.614 38.9061 36.4125C38.9107 36.2015 38.8264 36.0796 38.6717 36.0421ZM24.7217 16.3171C24.0092 16.3781 23.1514 16.5093 22.1436 16.7062C21.1357 16.8984 20.2029 17.1421 19.3404 17.4281C18.4779 17.714 17.5967 18.1125 16.7014 18.6187C15.8014 19.125 15.0373 19.7062 14.4045 20.3531C13.7717 21 13.2561 21.8109 12.8529 22.7906C12.4498 23.7656 12.2482 24.839 12.2482 26.0109C12.2482 27.2812 12.4686 28.4109 12.9186 29.4093C13.3639 30.4078 13.9592 31.1906 14.7092 31.7718C15.4545 32.3531 16.3029 32.8078 17.2404 33.1406C18.1779 33.4734 19.1717 33.6234 20.2029 33.5812C21.2342 33.539 22.242 33.3796 23.2217 33.0984C24.1967 32.8218 25.1154 32.3765 25.9686 31.7718C26.8217 31.1671 27.5201 30.45 28.0686 29.6296C28.2701 29.939 28.4482 30.1687 28.6076 30.3187L29.0154 30.7359C29.2873 31.0125 29.7045 31.4203 30.267 31.9593C30.8248 32.4984 31.3967 33.0234 31.9686 33.539L36.8623 28.8562L36.5811 28.6265C36.3795 28.4718 36.1404 28.2515 35.8686 27.9562C35.5967 27.6656 35.3248 27.3421 35.0623 26.9953C34.7951 26.6484 34.5654 26.2406 34.3732 25.7812C34.1811 25.3218 34.0826 24.8765 34.0826 24.4453V12.1265C34.0826 11.6531 33.9936 11.1421 33.8154 10.589C33.6326 10.0406 33.3139 9.44058 32.8451 8.7937C32.3764 8.14683 31.7951 7.56558 31.1014 7.05933C30.4029 6.55308 29.4748 6.12183 28.3076 5.77495C27.1451 5.42808 25.842 5.25464 24.4076 5.25464C22.9404 5.25464 21.5764 5.42808 20.3014 5.76558C19.0311 6.10776 17.9436 6.56245 17.0342 7.13433C16.1295 7.7062 15.3514 8.36714 14.7045 9.12183C14.0576 9.87651 13.5748 10.664 13.2607 11.4843C12.9467 12.3046 12.7873 13.1343 12.7873 13.9734L19.1248 14.5312C19.3826 13.7625 19.7295 13.0968 20.1561 12.525C20.5873 11.9531 20.9951 11.5406 21.3654 11.2828C21.7404 11.025 22.1436 10.8187 22.5701 10.664C23.0014 10.5093 23.292 10.4296 23.442 10.4109C23.592 10.3968 23.7092 10.3921 23.7983 10.3921C25.0498 10.3921 25.917 10.7625 26.4045 11.4984C26.7092 11.9437 26.8592 12.6187 26.8592 13.5281V16.1812C26.1467 16.2093 25.4342 16.2562 24.7217 16.3171ZM26.8639 23.4375C26.8639 24.2156 26.7607 24.9234 26.5592 25.5468C26.1279 26.9109 25.3076 27.7687 24.1029 28.1156C23.0529 28.4249 22.0545 28.2703 21.1076 27.6562C20.0998 27 19.5982 26.0718 19.5982 24.8765C19.5982 23.9437 19.8326 23.1468 20.3014 22.4812C20.7701 21.8203 21.3936 21.3234 22.1764 20.9953C22.9592 20.6671 23.7232 20.4328 24.4732 20.2968C25.2186 20.1562 26.0201 20.0718 26.8639 20.0437V23.4375ZM42.5764 33.6984C42.3748 33.4453 41.8311 33.2812 40.9404 33.1968C40.0498 33.1125 39.2764 33.1171 38.6107 33.2156C37.8936 33.3 37.1529 33.5062 36.3936 33.8437C35.6295 34.1765 35.2967 34.4578 35.3811 34.6781L35.4139 34.739L35.4561 34.7718L35.5217 34.7812H35.7373C35.7748 34.7812 35.8217 34.7765 35.8873 34.7718C35.9529 34.7671 36.0139 34.7578 36.0701 34.7531C36.1264 34.7484 36.2061 34.739 36.3092 34.7343C36.4076 34.7296 36.5014 34.7156 36.5904 34.7015C36.6045 34.7015 36.7639 34.6875 37.0732 34.6593C37.3826 34.6312 37.6076 34.6125 37.7436 34.5984C37.8795 34.5843 38.1092 34.5703 38.4232 34.5562C38.7373 34.5421 38.9904 34.5421 39.1779 34.5562C39.3654 34.5703 39.5764 34.589 39.8154 34.6078C40.0545 34.6265 40.2467 34.6687 40.3967 34.7343C40.5467 34.7953 40.6592 34.875 40.7295 34.9734C40.9733 35.2828 40.9264 35.9671 40.5889 37.0312C40.2514 38.0953 39.9326 38.9437 39.6326 39.5718C39.5014 39.839 39.5014 40.0031 39.6326 40.0734C39.7639 40.1437 39.9467 40.0781 40.1904 39.8859C40.9217 39.314 41.5311 38.4515 42.0233 37.2937C42.3092 36.6093 42.5154 35.8968 42.6373 35.1515C42.7498 34.4062 42.7311 33.9234 42.5764 33.6984Z"/>
    </svg>
  );

  const pinterestAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
     <path d="M24.0123 6C19.8152 5.99734 15.749 7.46132 12.517 10.1388C9.28491 12.8163 7.0901 16.539 6.31204 20.6632C5.53398 24.7874 6.22159 29.0538 8.25597 32.7247C10.2903 36.3957 13.5436 39.2404 17.4532 40.767C17.2957 39.3428 17.1517 37.1535 17.514 35.5988C17.8425 34.1925 19.6246 26.6505 19.6246 26.6505C19.6246 26.6505 19.0868 25.5728 19.0868 23.9798C19.0868 21.4755 20.5381 19.608 22.345 19.608C23.8795 19.608 24.6221 20.76 24.6221 22.1438C24.6221 23.6873 23.6388 25.9958 23.1303 28.1355C22.7072 29.9265 24.0303 31.389 25.7966 31.389C28.9963 31.389 31.4556 28.014 31.4556 23.145C31.4556 18.8363 28.3573 15.8235 23.9358 15.8235C18.8146 15.8235 15.8084 19.6643 15.8084 23.6333C15.8084 25.1813 16.4047 26.8395 17.1472 27.7418C17.2112 27.8098 17.2564 27.8932 17.2785 27.9839C17.3006 28.0746 17.2987 28.1695 17.2732 28.2593C17.136 28.8263 16.8322 30.0503 16.7737 30.3C16.695 30.6285 16.5127 30.6983 16.1707 30.5408C13.9206 29.4945 12.5165 26.2073 12.5165 23.5658C12.5165 17.889 16.6432 12.6758 24.4106 12.6758C30.6546 12.6758 35.5081 17.124 35.5081 23.0708C35.5081 29.274 31.5952 34.2668 26.1679 34.2668C24.3431 34.2668 22.6285 33.3195 22.0412 32.199L20.9206 36.4785C20.5134 38.0423 19.4153 40.002 18.6818 41.1968C21.1568 41.962 23.7679 42.184 26.3367 41.8476C28.9054 41.5112 31.3712 40.6243 33.5657 39.2476C35.7603 37.8708 37.6317 36.0366 39.0523 33.8703C40.4729 31.704 41.4091 29.2566 41.7971 26.6952C42.185 24.1339 42.0154 21.519 41.3 19.0292C40.5846 16.5394 39.3401 14.2333 37.6517 12.2686C35.9632 10.3038 33.8706 8.72664 31.5166 7.64479C29.1627 6.56293 26.603 6.0019 24.0123 6Z"/>
    </svg>
  );

  const youtubeAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 30L30.38 24L20 18V30ZM43.12 14.34C43.38 15.28 43.56 16.54 43.68 18.14C43.82 19.74 43.88 21.12 43.88 22.32L44 24C44 28.38 43.68 31.6 43.12 33.66C42.62 35.46 41.46 36.62 39.66 37.12C38.72 37.38 37 37.56 34.36 37.68C31.76 37.82 29.38 37.88 27.18 37.88L24 38C15.62 38 10.4 37.68 8.34 37.12C6.54 36.62 5.38 35.46 4.88 33.66C4.62 32.72 4.44 31.46 4.32 29.86C4.18 28.26 4.12 26.88 4.12 25.68L4 24C4 19.62 4.32 16.4 4.88 14.34C5.38 12.54 6.54 11.38 8.34 10.88C9.28 10.62 11 10.44 13.64 10.32C16.24 10.18 18.62 10.12 20.82 10.12L24 10C32.38 10 37.6 10.32 39.66 10.88C41.46 11.38 42.62 12.54 43.12 14.34Z"/>
    </svg>
  );

  const facebookAds = () => (
    <svg className={isDarkMode ? "light-table-icon-svg" : "table-icon-svg"} width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M34 4.28846V10.6346H30.3657C29.0386 10.6346 28.1435 10.9231 27.6806 11.5C27.2176 12.0769 26.9861 12.9423 26.9861 14.0962V18.6394H33.7685L32.8657 25.7548H26.9861V44H19.9028V25.7548H14V18.6394H19.9028V13.399C19.9028 10.4183 20.7052 8.10657 22.3102 6.46394C23.9151 4.82131 26.0525 4 28.7222 4C30.9907 4 32.75 4.09615 34 4.28846Z"/>
    </svg>
  );

  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(props.groups && props.groups.length > 0 ? props.groups[0] : null);
  const [isCollapsed, setIsCollapsed] = useState(props.collapsed || false);
  const dropdownRef = useRef(null);
  const tableContainerRef = useRef(null);
  const collapsible = props.collapsed == true || props.collapsed == false ? true : false;
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  
  useEffect(() => {
    if (collapsible) {
      // Adjust max-height based on the collapsed state and the content of the table
      const maxHeight = isCollapsed ? "0px" : `${tableContainerRef.current.scrollHeight}px`;
      tableContainerRef.current.style.maxHeight = maxHeight;
    }
  }, [isCollapsed]);
  
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const selectGroup = (group) => {
    setSelectedGroup(group);
    setShowDropdown(false);
  };

  const baseUrl = props.baseUrl ? props.baseUrl.replace(/\/$/, "") : null;

  const renderGroupSelector = () => {
    if (!props.groups || props.groups.length === 0) {
      return null;
    }

    return (
      <div ref={dropdownRef} className="metric-table-group-selector-container" style={{ position: 'relative', display: 'inline-block', width: "170px" }}>
        <button onClick={toggleDropdown} style={{ color: 'white', backgroundColor: 'transparent', fontSize: '16px', cursor: 'pointer', display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", border: "none" }}>
          <span className="title-color-primary">{selectedGroup || 'Select Group'}</span>
          {!showDropdown ? chevronDown : chevronUp}
        </button>
        {showDropdown && (
          <div className="metric-table-group-selector" style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1
          }}>
            {props.groups.map((group) => (
              <div key={group} style={{ padding: '8px 12px', cursor: 'pointer', textAlign: 'left' }} onClick={() => selectGroup(group)}>
                {group}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderTopSummaryRow = () => {
    if (props.topSummaryRow) {
      const dim = jsDig(["dimension"], props.topSummaryRow);
      const topSummaryData = jsDig(["data"], props.topSummaryRow);
      return (
        <>
          <tr className="top-summary-row">
            <th className="dimension-column lite-table-cell lite-border-right">{dim}</th>
            {props.headerOrder.map((metric, index) => {
              const metricName = toLower(metric);
              const metricValue = selectedGroup ? jsDig([toLower(selectedGroup), metricName, "total"], topSummaryData) : jsDig([metricName, "total"], topSummaryData);
              return (
                <React.Fragment key={index}>
                  {metricValue ? 
                    formatCells(metricValue, metricName, false, false, false, dim) : 
                    renderBlankRow(false)
                  }
                </React.Fragment>
              );
            })}
          </tr>

          {props.tableName == "PPC Portfolio Performance" && ( // Add comparison period row for PPC Portfolio Performance table
            <tr className="top-summary-row">
              <td className={`dimension-column lite-table-cell lite-border-right`}>
                Comparison Period
              </td>
              {props.headerOrder.map((metric, index) => {
                const metricName = toLower(metric);
                const metricValue = selectedGroup ? jsDig([toLower(selectedGroup), metricName, "total"], topSummaryData) : jsDig([metricName, "total"], topSummaryData);
                const last = props.headerOrder.length - 1 == index ? true : false
                return (
                  <React.Fragment key={index}>
                    {metricValue ? 
                      formatCells(metricValue, metricName, false, false, false, "comparison") : 
                      renderBlankRow(false)
                    }
                  </React.Fragment>
                );
              })}
            </tr>
          )}
        </>
      )
    } 
  }

  const renderTableHeader = () => {
    let columnWidth = 100 / (props.headerOrder.length + 1);
    return (
      <>
        <tr className="table-header">
        <th className={`lite-border-right lite-border-bottom`}></th>
          {props.headerOrder.map((metric, index) => {
            const last = props.headerOrder.length - 1 == index ? true : false
            return ( 
              <th key={index} className={`${last == true ? "" : "lite-border-right"} lite-border-bottom`} colSpan={props.subHeaderOrder.length} style={{width: `${columnWidth}%`}}>
                {getColumnName(metric)}
              </th>
            )
          })}
        </tr>
        <tr className="table-header sh">
          <th className="first-th  lite-border-right lite-border-bottom"></th>
          {props.headerOrder.map((metric, index) => {
            const last = props.headerOrder.length - 1 == index ? true : false
            return props.subHeaderOrder.map((subHeader, index) => {
              if ((metric == "cpa" || metric == "roas" || metric == "mer") && subHeader == "L7D Avg.") { return <th className="lite-border-bottom" key={`${subHeader}-${index}`}></th> }

              if (subHeader == "buy_box_percentage") {subHeader = "Buy Box %"}
              if (metric == "yesterday" && subHeader == "revenue") {subHeader = "Revenue"}
              if (metric == "last_30" && subHeader == "revenue") {subHeader = "Avg. Daily Rev."}

              let customTooltip = null;
              if (subHeader == "Growth Rate") {
                customTooltip = <CustomTooltip 
                  faClass="far fa-question-circle pl-2" 
                  message={
                    <>
                      <p className="small mb-3">This metric looks at the YoY performance of the last 30 days and compares it to the YoY performance of the previous 30 days.</p>
                      <p className="small mb-3">For example, last 30 days we were up 20%+ YoY, but the previous 30 days we were up 10% YoY, then we have increased performance 10 percentage points in the right direction</p>
                      <p className="small mb-3">This metric gives us an accurate, recent view on performance that takes into account all seasonality of the business.</p>
                    </>
                  } 
                  inline={true} 
                />
              }

              return (
                <th
                  className={`lite-border-bottom ${
                    (subHeader === "Y/Y" || subHeader === "Proj.") && last === false
                      ? "lite-border-right "
                      : " "
                    }${(subHeader.toString() || "").replace(/[^a-zA-Z0-9-_]/g, "")}-cell subheader-cell`}
                  key={`${subHeader}-${index}`}
                >
                  {subHeader}
                  {customTooltip}
                </th>
              );
            })
          })}
        </tr>
      </>
    )
  };

  const renderTableRows = () => {
    return props.dimensions.map((dim) => {
      const borderClass = dim.toLowerCase() === "ytd" ? "lite-border-top" : false;
      // Get the name of the current month
      const monthName = new Date().toLocaleString('en', { month: 'long' });
      let showProjection = false;
      if (dim.toLowerCase() == monthName.toLowerCase()) { showProjection = true; }
      if (dim.toLowerCase() == "ytd") { showProjection = false; }
      if (dim.toLowerCase() == "total") { showProjection = true; }
      return (
        <React.Fragment key={dim}>
          <tr className="regular-row">
            <th className={`dimension-column lite-table-cell lite-border-right ${borderClass ? borderClass : ""}`}>
              {dim}
              {(props.containsUrl && (dim != "(not set)")) && (
                <a href={`${baseUrl ? baseUrl : ""}${dim}`} target="_blank" rel="noreferrer" style={{marginLeft: "8px"}}>
                  <i className="fas fa-external-link-alt"></i>
                </a>
              )}
            </th>
            {props.headerOrder.map((metric, index) => {
              const metricName = toLower(metric);
              const metricValue = selectedGroup ? jsDig([toLower(selectedGroup), metricName, dim], props.data) : jsDig([metricName, dim], props.data);
              const last = props.headerOrder.length - 1 == index ? true : false
              return (
                <React.Fragment key={index}>
                  {metricValue ? 
                    formatCells(metricValue, metricName, borderClass, last, showProjection, dim) : 
                    renderBlankRow(borderClass)
                  }
                </React.Fragment>
              );
            })}
          </tr>

          {props.tableName == "PPC Portfolio Performance" && ( // Add comparison period row for PPC Portfolio Performance table
            <tr className="regular-row lite-border-bottom">
              <td className={`dimension-column lite-table-cell lite-border-right ${borderClass ? borderClass : ""}`}>
                Comparison Period
              </td>
              {props.headerOrder.map((metric, index) => {
                const metricName = toLower(metric);
                const metricValue = selectedGroup ? jsDig([toLower(selectedGroup), metricName, dim], props.data) : jsDig([metricName, dim], props.data);
                const last = props.headerOrder.length - 1 == index ? true : false
                return (
                  <React.Fragment key={index}>
                    {metricValue ? 
                      formatCells(metricValue, metricName, borderClass, last, showProjection, "comparison") : 
                      renderBlankRow(borderClass)
                    }
                  </React.Fragment>
                );
              })}
            </tr>
          )}
        </React.Fragment>
      );
    })
  };

  const renderBlankRow = (borderClass) => {
    return (
      <>
        {
          props.subHeaderOrder.map((subHeader, index) => {
            return (
              <td className={`${borderClass ? borderClass : ""} ${index == 0 ? "" : ""} ${index == props.subHeaderOrder.length - 1 && last == false ? "lite-border-right" : ""}`} key={index}>
                <div className="lite-table-cell">&nbsp;</div>
              </td>
            )
          })
        }
      </>
    )
  }

  // Helper function to format individual metric
  const formatCells = (metric, metricName, borderClass, last, showProjection, dim) => {
    const urlParams = new URLSearchParams(window.location.search);
    const selectedYear = urlParams.get("year") || new Date().getFullYear().toString(); // Default to the current year
    const thisYear = parseInt(selectedYear);
    const lastYear = thisYear - 1;
    if (parseInt(selectedYear) !== new Date().getFullYear()) { // set showProjection to false if year parameter is not current year
      showProjection = false;
    }

    return (
      <>
        {props.subHeaderOrder.map((subHeader, index) => {
          let metricValue = null;

          if (subHeader == lastYear) {
            metricValue = metric["previous"];
          } else if (subHeader == thisYear) {
            if (showProjection) {
              metricValue = metric["projection"];
            } else {
              metricValue = metric["current"];
            }
          } else if (subHeader == "Diff") {
            metricValue = metric["difference"];
          } else if (subHeader == "Y/Y") {
            if (showProjection) {
              metricValue = metric["projection_comparison"];
            } else {
              metricValue = metric["comparison"];
            }
          } else if (subHeader == "L30D") {
            metricValue = metric["current"];
          } else if (subHeader == "YoY") {
            metricValue = metric["comparison"];
          } else if (subHeader == "MoM") {
            metricValue = metric["mom"];
          } else if (subHeader == "Growth Rate") {
            metricValue = metric["growth_rate"];
          } else if (subHeader == "revenue") {
            metricValue = metric["revenue"];
          } else if (subHeader == "buy_box_percentage") {
            metricValue = metric["buy_box_percentage"];
          } else if (subHeader == "MTD") { 
            if (dim == "comparison") { metricValue = metric["prev_mtd"] } else { metricValue = metric["mtd"] } // Used for PPC Portfolio Table
          } else if (subHeader == "L7D") {
            if (dim == "comparison") { metricValue = metric["prev_l7d"] } else { metricValue = metric["l7d"] } // Used for PPC Portfolio Table
          } else if (subHeader == "L7D Avg.") {
            if (dim == "comparison") { metricValue = metric["prev_l7d_average"] } else { metricValue = metric["l7d_average"] } // Used for PPC Portfolio Table
          } else if (subHeader == "Yesterday") {
            if (dim == "comparison") { metricValue = metric["prev_yesterday"] } else { metricValue = metric["yesterday"] } // Used for PPC Portfolio Table
          } else if (subHeader == "Proj.") {
            if (dim == "comparison") { metricValue = metric["prev_this_month"] } else { metricValue = metric["projected"] } // Used for PPC Portfolio Table
          } else {
            metricValue = metric; // If the subheader doesn't match any expected values, assume it's a flat dataset with no groupings
          }

          const showCorner = (subHeader == thisYear && showProjection == true && metricValue) || (subHeader == thisYear && dim == "Total" && metricValue);
          let shouldHide = false;
          if (subHeader == "L7D Avg." && (metricName == "cpa" || metricName == "roas" || metricName == "mer")) {
            shouldHide = true;
          }

          return (
          <td className={`corner-parent ${borderClass ? borderClass : ""} ${subHeader === thisYear && showProjection === true && dim !== "YTD" ? "project-true" : ""} ${index === props.subHeaderOrder.length - 1 && !last ? "lite-border-right" : ""}`} key={index}>
            <div className={`lite-table-cell`}>
              <div>
                {(metricValue != null && metricValue !== 0) &&
                <span className="project-hover">{showCorner && <>{`MTD: ${formatMetric(metricName, metric["current"], subHeader, false)}`}</>}</span>
                }
                {shouldHide ? "" : (
                  formatMetric(metricName, metricValue, subHeader, false)
                )}
              </div>
            </div>
            <div className={`${showCorner ? "td-corner" : ""}`}>
            </div>
          </td>
        );  
        })}
      </>
    )
  };

  const getColumnName = (metric) => {
    switch (metric) {
      case "spend":
        return "Spend";
      case "clicks":
        return "Clicks";
      case "conversions":
        return "Conversions";
      case "revenue":
        return "Revenue";
      case "roas":
        return "ROAS";
      case "cpa":
        return "CPA";
      case "mer":
        return "MER";
      case "frequency":
        return "Frequency";
      case "conversion_rate":
        return "Conversion Rate";
      case "sessions":
        return "Sessions";
      case "paid_sessions":
        return "Paid Sessions";
      case "organic_sessions":
        return "Organic Sessions";
      case "impressions":
        return "Impressions";
      case "reach":
        return "Reach";
      case "new_customers":
        return "New Customers";
      case "aov":
        return "AOV";
      case "open_rate":
        return "Open Rate";
      case "ctr":
        return "CTR";
      case "bounce_rate":
        return "Bounce Rate";
      case "email_list_growth":
        return "Email List Growth";
      case "affiliates":
        return "Affiliate";
      case "direct":
        return "Direct";
      case "referral":
        return "Referral";
      case "audio":
        return "Audio";
      case "mobile_push_notifications":
        return "Mobile Push Notifications";
      case "sms":
        return "SMS";
       case "last_30":
        return "Last 30 Days";
      default:
        return startCase(metric);
    }
  }

  const renderTableName = (tableName, selectedGroup = "") => {
    if (selectedGroup != "") {
      selectedGroup = "- " + selectedGroup
    }
    let tableIcon = ""
    if (tableName.toLowerCase().includes("search")) {
      if (selectedGroup.toLowerCase().includes("google ads")) {
        tableIcon = googleAds()
      } else if (selectedGroup.toLowerCase().includes("microsoft ads")) {
        tableIcon = microsoftAds()
      }
      else tableIcon = searchIcon()
    } else if (tableName.toLowerCase().includes("social")) {
      if (selectedGroup.toLowerCase().includes("facebook")) {
        tableIcon = facebookAds()
      } else if (selectedGroup.toLowerCase().includes("tiktok")) {
        tableIcon = tiktokAds()
      }
      else tableIcon = socialIcon()
    } else if (tableName.toLowerCase().includes("facebook") && tableName.toLowerCase().includes("instagram")) {
      tableIcon = metaAds()
    } else if (tableName.toLowerCase().includes("tiktok")) {
      tableIcon = tiktokAds()
    } else if (tableName.toLowerCase().includes("youtube")) {
      tableIcon = youtubeAds()
    } else if (tableName.toLowerCase().includes("pinterest")) {
      tableIcon = pinterestAds()
    } else if (tableName.toLowerCase().includes("amazon")) {
      tableIcon = amazonAds()
    }

    else tableIcon = ""

    return(
    <div className="lite-flexbox justify-content-center">
      <div className="">
        {tableIcon}
      </div>
      <div className="table-name">
        {tableName} <span className="desktop-only">{selectedGroup}</span>
      </div>
    </div>
    )
  }

  const exportTableToCSV = () => {
    const rows = [];
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    // Headers
    const headers = ['Dimension'];
    const subHeaders = [''];
    
    props.headerOrder.forEach((header) => {
        headers.push(getColumnName(header));
        headers.push(''); // Empty space for the subheader row
        headers.push('');
    });

    props.headerOrder.forEach((header) => {
        subHeaders.push(previousYear);
        subHeaders.push(currentYear);
        subHeaders.push('Y/Y');
    });

    rows.push(headers.join(','));
    rows.push(subHeaders.join(','));

    // Data Rows
    props.dimensions.forEach((dim) => {
        const row = [dim]; // First column is the dimension name
        
        props.headerOrder.forEach((metric) => {
            const metricName = toLower(metric);
            const metricData = selectedGroup
                ? jsDig([toLower(selectedGroup), metricName, dim], props.data)
                : jsDig([metricName, dim], props.data);
                
            // Handling each subheader value
            let currentValue = '';
            let previousValue = '';
            let yoyValue = '';

            if (metricData) {
                previousValue = metricData['previous'] !== undefined ? formatMetric(metricName, metricData['previous'], previousYear) : '';
                currentValue = metricData['current'] !== undefined ? formatMetric(metricName, metricData['current'], currentYear) : '';
                yoyValue = metricData['comparison'] !== undefined ? formatMetric(metricName, metricData['comparison'], 'Y/Y') : '';
            }

            // Ensure proper formatting by enclosing values in quotes if they contain commas or special characters
            row.push(`"${previousValue}"`);
            row.push(`"${currentValue}"`);
            row.push(`"${yoyValue}"`);
        });

        rows.push(row.join(','));
    });

    // Create and download the CSV file
    const csvContent = "data:text/csv;charset=utf-8," + rows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${props.tableName || 'table_data'}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

  return (
    <>
      <div className={`metric-table-container ${props.tableName.includes("L60D") ? "l60d" : ""}`} style={props.disabledMsg ? {opacity: "0.5"} : null}>
        {/* Export Button */}
        {/* <button onClick={exportTableToCSV}>Export to CSV</button> */}
        
        <div className={`table-title lite-flexbox ${isCollapsed && 'collapsed'} ${!props.groups || props.groups.length === 0 ? "no-group" : "group-present"} justify-content-space-between ${collapsible && 'collapsible'}`}>
          <div className={`table-title-left ${isCollapsed && 'collapsed'}`}>{renderGroupSelector()}</div>
          <div className={`table-title-center ${isCollapsed && 'collapsed'} ${collapsible && 'collapsible'}`} onClick={collapsible ? toggleCollapse : undefined}>{renderTableName(props.tableName, selectedGroup ? selectedGroup : "")}</div>
          <div className={`table-title-right ${isCollapsed && 'collapsed'} ${collapsible && 'collapsible'}`} onClick={collapsible ? toggleCollapse : undefined}>
            <div className={collapsible ? "chevron" : "d-none"}>
              {isCollapsed ? chevronDown : chevronUp}
            </div>
          </div>
        </div>
        <div className={`lite-table-container ${props.tableName == "PPC Portfolio Performance" && "unlimited-maxheight"}`} ref={tableContainerRef} style={{
          overflow: 'hidden',
          transition: 'max-height 0.5s ease',
          maxHeight: isCollapsed ? '0px' : '1700px'
        }}>
          <table>
            <thead>
              {renderTableHeader()}
            </thead>
            <tbody>
              {renderTopSummaryRow()}
              {renderTableRows()}
            </tbody>
          </table>
        </div>
      </div>
      {props.disabledMsg && (
        <div className="coming-soon-container">
          {props.disabledMsg}
        </div>
      )}
    </>
  );
}
